import React, { createContext, useContext, useState } from 'react';

const LoginModalContext = createContext({
  isOpen: false,
  openLogin: () => {},
  closeLogin: () => {},
});

export const useLoginModal = () => useContext(LoginModalContext);

export function LoginModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const value = {
    isOpen,
    openLogin: () => setIsOpen(true),
    closeLogin: () => setIsOpen(false),
  };

  return <LoginModalContext.Provider value={value}>{children}</LoginModalContext.Provider>;
}
